export const joinUrl = (base, path) =>
    `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;